import { render } from "./AposInputBoolean.vue?vue&type=template&id=60780069&scoped=true"
import script from "./AposInputBoolean.vue?vue&type=script&lang=js"
export * from "./AposInputBoolean.vue?vue&type=script&lang=js"

import "./AposInputBoolean.vue?vue&type=style&index=0&id=60780069&lang=scss&scoped=true"

import exportComponent from "../../../../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60780069"],['__file',"schema/ui/apos/components/AposInputBoolean.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "60780069"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('60780069', __exports__)) {
    api.reload('60780069', __exports__)
  }
  
  module.hot.accept("./AposInputBoolean.vue?vue&type=template&id=60780069&scoped=true", () => {
    api.rerender('60780069', render)
  })

}


export default __exports__